export const validationOptions = {
  validateOnBlur: true,
  validateOnModelUpdate: false,
};

export const options = {
  accreditationBody: [
    { value: 'eaccme', label: 'European CME credits' },
    { value: 'accme', label: 'AMA PRA Category 1 Credits™ (US or outside Europe)' },
  ],
  yesOrNo: [
    'No',
    'Yes',
  ],
  userIsDoctorOfMedicine: [
    { value: false, label: 'No' },
    { value: true, label: 'Yes' },
  ],
  percentageOfNewInformation: [
    '25%',
    '50%',
    '75%',
    '100%',
  ],
};

export enum ActivityWhatDidYouLikeOptions {
  IncreasedKnowledge = 'increased_knowledge',
  ImproveCommunicationWithHealthcareTeam = 'improve_communication_with_healthcare_team',
  InformationToReviewLater = 'information_to_review_later',
  ApplyInformationOnPractice = 'apply_information_on_practice',
  FacilitatedValuesOrEthicsToInterprofessionalPractice = 'facilitated_values_or_ethics_to_interprofessional_practice',
}

export const activityWhatDidYouLikeFields = [
  { value: ActivityWhatDidYouLikeOptions.IncreasedKnowledge, label: 'It increased my knowledge.' },
  { value: ActivityWhatDidYouLikeOptions.ImproveCommunicationWithHealthcareTeam, label: 'It will improve my communication with the healthcare team.' },
  { value: ActivityWhatDidYouLikeOptions.InformationToReviewLater, label: 'It provided information in ways that I can review again later.' },
  { value: ActivityWhatDidYouLikeOptions.ApplyInformationOnPractice, label: 'It gave me the opportunity to apply information to realistic scenarios in my practice.' },
  { value: ActivityWhatDidYouLikeOptions.FacilitatedValuesOrEthicsToInterprofessionalPractice, label: 'It facilitated applying values/ethics to interprofessional practice.' },
];

export enum TeacherRatingsOptions {
  TeachingStrategies = 'teachingStrategies',
  Expertise = 'expertise',
  Engaging = 'engaging',
  ContentSelection = 'contentSelection',
}

export const teacherRatingsFields = [
  {
    title: (name: string) => `Please rate the quality of ${name}’s teaching strategies.`,
    value: TeacherRatingsOptions.TeachingStrategies,
  },
  {
    title: (name: string) => `How would you rate ${name}’s expertise in the subject matter?`,
    value: TeacherRatingsOptions.Expertise,
  },
  {
    title: (name: string) => `Please rate ${name}’s ability to engage learners.`,
    value: TeacherRatingsOptions.Engaging,
  },
  {
    title: (name: string) => `Please rate ${name}’s choice of content.`,
    value: TeacherRatingsOptions.ContentSelection,
  },
];

export enum ActivityCredibilityRatingsOptions {
  ChangePracticeBasedOnActivity = 'changePracticeBasedOnActivity',
  ClinicallyRelevant = 'clinicallyRelevant',
  BalancedAndObjective = 'balancedAndObjective',
  FreeOfCommercialBias = 'freeOfCommercialBias',
  PercentageOfNewInformation = 'percentageOfNewInformation',
}

export const activityCredibilityRatingsFields = [
  {
    title: 'Will you change the way you practice based on this activity?',
    options: options.yesOrNo,
    value: ActivityCredibilityRatingsOptions.ChangePracticeBasedOnActivity,
  },
  {
    title: 'Was the content clinically relevant?',
    options: options.yesOrNo,
    value: ActivityCredibilityRatingsOptions.ClinicallyRelevant,
  },
  {
    title: 'Do you feel the activity was balanced and objective?',
    options: options.yesOrNo,
    value: ActivityCredibilityRatingsOptions.BalancedAndObjective,
  },
  {
    title: 'Do you feel the activity was free of commercial bias?',
    options: options.yesOrNo,
    value: ActivityCredibilityRatingsOptions.FreeOfCommercialBias,
  },
  {
    title: 'Approximately what percentage of this content was NEW to you?',
    options: options.percentageOfNewInformation,
    value: ActivityCredibilityRatingsOptions.PercentageOfNewInformation,
  },
];